export default __webpack_public_path__ + "static/media/26.b6787083.png";